const getHostToken = (reservation) => reservation.party?.find(
  (i) => i.type === 'host'
)?.token;

export default getHostToken;
